import React, { useState } from 'react';
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';

function Tab1({ deliveryNoteData, activityboll, detail,postdeliverydate,postdeliverytime,postcheckbox }) {
  const [showActivity, setShowActivity] = useState(true);

  return (
    <div
      className="row sidebarbox m-0"
      style={{
        padding: "8px",
        borderRadius: "5px",
        maxHeight: "74vh",
        minHeight: "74vh",
        overflowY: "scroll",

      }}
    >
      <div style={{ maxHeight: "74vh", }}>
        <div className="d-flex gap-3 mb-2" >
          <div className="" style={{ width: '50%' }}>
            <Input
              id="numberInput"
              label="No"
              readOnly
              value={deliveryNoteData?.name}
              style={{ height: '30px' }}
            />
          </div>
          <div className="" style={{ width: '50%' }}>
            <Input
              id="deliveryDate"
              label="Delivery Date"
              readOnly
              value={deliveryNoteData?.posting_date || ''}
              iconRight={<GetIcon iconName="GoClock" size={18} />}
              style={{ height: '30px' }}
            />

          </div>
        </div>

        <div className="col-12 mb-3" >
          {/* <Input
            id="picklist"
            label="Pick List No."
            readOnly
            value={deliveryNoteData?.customer || 'No customer selected'}
            style={{ height: '30px' }}
          /> */}
          {/* {console.log("setselectedpicklist",detail.picklist)} */}
           <SelectSearch
                      list={detail.picklist}
                      label="Select Pick List No."
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={detail.selectedpicklist}
                      onChange={(val) => detail.setselectedpicklist(val)}
                    /> 
        </div>
        {console.log("check customer customer",deliveryNoteData)}
        <div className="col-12 mb-3" >
          <Input
            id="customer"
            label="Customer"
            readOnly
            value={deliveryNoteData?.message?.customer || 'No customer selected'}
            style={{ height: '30px' }}
          />
        </div>

        <div className="col-12 mb-3" >
          <Input
            id="billingType"
            label="Billing Type"
            readOnly
            value={deliveryNoteData?.message?.custom_billing_type || 'No Billing Type selected'}
            style={{ height: '30px' }}
          />
        </div>
        <div className="col-12 mb-3" >
          <Input
            id="orderType"
            label="Order Type"
            readOnly
            value={deliveryNoteData?.message?.order_type || 'No Order Type selected'}
            style={{ height: '30px' }}
          />
        </div>

        <div className="col-12 mb-3" >
          <Input
            id="againstOrder"
            label={deliveryNoteData?.hasOwnProperty('against_sales_order')
              ? 'Against Sales Order'
              : 'Against Purchase Receipt'}
            readOnly
            value={deliveryNoteData?.against_sales_order || ''}
            style={{ height: '30px' }}
          />
        </div>

        <div className="col-12 mb-3">
          <div className="mb-3">
            <Input
            type='date'
              id="deliveryDate"
              label="Delivery Date"
              // value={deliveryNoteData?.lr_date || ''}
              value={postdeliverydate.postdeliverydate ? postdeliverydate.postdeliverydate : deliveryNoteData?.lr_date || ""}
            onChange={(e) => postdeliverydate.setpostdeliverydate(e.target.value)}
              iconRight={<GetIcon iconName="GoClock" size={18} />}
              style={{ height: '30px' }}
            />

          </div>
        </div>

        <div className="col-12" style={{ marginBottom: '12px' }}>
          <Input
          type='time'
            id="postingTime"
            label="Post Time two"
              value={postdeliverytime.postdeliverytime ? postdeliverytime.postdeliverytime : deliveryNoteData?.posting_time?.slice(0, 5) || ''}
            onChange={(e) => postdeliverytime.setpostdeliverytime(e.target.value)}
            iconRight={<GetIcon iconName="GoClock" size={18} />}
            style={{ height: '30px' }}
          />
          
        </div>

        <div className="col-12">
          <Input
            id="remarks"
            label="Remarks"
            style={{ height: '30px' }}
          />
        </div>

        <div className="col-12">
          <div className='d-flex align-items-center pb-2' style={{ marginTop: '12px' }}>
            {postcheckbox == true ? <input
              type="checkbox"
              checked
              onClick={()=>{postcheckbox.setpostcheckbox(false)}}
              style={{ width: '15px', height: '15px', borderRadius: '4px', marginRight: '8px' }}
            /> : <input
              type="checkbox"
              onClick={()=>{postcheckbox.setpostcheckbox(true)}}
              style={{ width: '15px', height: '15px', borderRadius: '4px', marginRight: '8px' }}
            />}
            
            <label style={{ color: '#00000099', fontSize: '13px' }}>
              Edit Posting Date and Time
            </label>
          </div>
        </div>

   <div>
          <CollapsibleSection title="Accounting Dimensions">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Cost Center"
                readOnly
                value={deliveryNoteData?.cost_center || 'Not specified'}
                style={{ height: '30px' }}
              />
            </div>
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Project"
                readOnly
                value={deliveryNoteData?.project || 'Not specified'}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Payment Terms">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Payment Terms"
                readOnly
                value={deliveryNoteData?.payment_terms || 'Not specified'}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Currency and Price List">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Currency"
                readOnly
                value={deliveryNoteData?.currency || 'Not specified'}
                style={{ height: '30px' }}
              />
            </div>
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Price List"
                readOnly
                value={deliveryNoteData?.selling_price_list || 'Not specified'}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Taxes and Charges">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Taxes and Charges"
                readOnly
                value={deliveryNoteData?.taxes_and_charges || 'Not specified'}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Terms & Conditions">
            <div className="col-lg-12 mt-1 mb-3">
              <Input
                label="Terms and Conditions"
                readOnly
                value={deliveryNoteData?.tc_name || 'Not specified'}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Additional Discount">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Additional Discount Percentage"
                readOnly
                value={`${deliveryNoteData?.additional_discount_percentage || 0}%`}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>
        </div>

        <div >
          <div className="col-12">
         <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
          <p className="firstcolor m-0">
            Activity
          </p>
          <GetIcon
            iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
            size={22}
          />
        </div>

            {showActivity && (
              <VersionHistory
                doctype="Delivery note"
                docname={deliveryNoteData?.name}
                activityboll={activityboll}
              />
            )}
          </div>
        </div>

      </div>
    </div>

  );
}

export default Tab1;